import { render } from "./groupHome.vue?vue&type=template&id=e23cb75e&scoped=true"
import script from "./groupHome.vue?vue&type=script&lang=js"
export * from "./groupHome.vue?vue&type=script&lang=js"

import "./groupHome.vue?vue&type=style&index=0&id=e23cb75e&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e23cb75e"]])

export default __exports__